import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import GAuth from 'vue-google-oauth2'

//import Welcome from "./components/Welcome.vue";
//import ListAppraisals from "./components/ListAppraisals.vue"
//import ViewAppraisal from "./components/ViewAppraisal.vue"
//import CreateAppraisal from "./components/CreateAppraisal.vue"

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const gauthOption = {
  clientId: '46212321174-ub9i9j7rpujvlh14nvgctfdlp91s984r.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(GAuth, gauthOption)

import App from './App.vue'

import { store } from './store/store'

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/home'
  },
  { path: '/home',   name: 'home',   component: () => import('./components/Welcome.vue') },
  { path: '/list',   name: 'list',   component: () => import('./components/ListAppraisals.vue') },
  { path: '/view',   name: 'view',   component: () => import('./components/ViewAppraisal.vue') },
  { path: '/create', name: 'create', component: () => import('./components/CreateAppraisal.vue') },
]

const router = new VueRouter({
  routes // short for `routes: routes`
})

/*
// TODO: redirect to login page if not logged in and trying to access a restricted page
// FIXME: ...but use vuex store, rather than local variables???
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
})
*/


// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store: store,
  router,
}).$mount('#app')
